import { get, post } from '../rest';

export default {
  getCompetences: params => get('/competences', params),
  updateCompetenceAnswers: params => post('/competences/answers', params),
};
